// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_no-0";